import React from 'react';

export const Cloud = ({ className = '', style = {}, size = 120, tone = '#ffffff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 200 100"
    width={size}
    className={className}
    style={style}
    aria-hidden="true"
  >
    <g fill={tone} filter="drop-shadow(0 4px 0 rgba(80,140,180,0.10))">
      <ellipse cx="55" cy="60" rx="38" ry="32" />
      <ellipse cx="100" cy="48" rx="48" ry="40" />
      <ellipse cx="148" cy="60" rx="40" ry="30" />
      <ellipse cx="78" cy="72" rx="32" ry="22" />
      <ellipse cx="130" cy="74" rx="36" ry="22" />
    </g>
  </svg>
);

export const Sun = ({ size = 90, className = '' }) => (
  <svg viewBox="0 0 100 100" width={size} className={className} aria-hidden="true">
    <g>
      {Array.from({ length: 12 }).map((_, i) => (
        <rect
          key={i}
          x="48"
          y="4"
          width="4"
          height="14"
          rx="2"
          fill="#f5c04a"
          transform={`rotate(${i * 30} 50 50)`}
        />
      ))}
      <circle cx="50" cy="50" r="22" fill="#ffd868" />
      <circle cx="50" cy="50" r="16" fill="#ffe28a" />
    </g>
  </svg>
);

export const Bird = ({ size = 80, flip = false, className = '' }) => (
  <svg
    viewBox="0 0 120 100"
    width={size}
    className={className}
    style={{ transform: flip ? 'scaleX(-1)' : 'none' }}
    aria-hidden="true"
  >
    <ellipse cx="62" cy="58" rx="34" ry="22" fill="#f7c7a4" />
    <circle cx="90" cy="46" r="14" fill="#f7c7a4" />
    <circle cx="93" cy="44" r="2.5" fill="#3a2a1a" />
    <path d="M100 46 l10 -2 l-8 6 z" fill="#e28a3a" />
    <path d="M40 40 Q60 20 76 46 Q58 46 40 40 Z" fill="#d99169" />
    <path d="M40 68 Q60 88 76 66 Q58 66 40 68 Z" fill="#d99169" />
    <path d="M28 62 Q20 66 24 74" stroke="#8d5a34" strokeWidth="2" fill="none" />
  </svg>
);

export const Leaf = ({ size = 40, className = '', color = '#7ac26f' }) => (
  <svg viewBox="0 0 60 60" width={size} className={className} aria-hidden="true">
    <path
      d="M8 44 C8 22 26 6 52 6 C52 30 34 52 12 52 Z"
      fill={color}
    />
    <path d="M14 46 L46 14" stroke="#5aa353" strokeWidth="2" fill="none" />
  </svg>
);

export const Star = ({ size = 30, className = '', color = '#ffd868' }) => (
  <svg viewBox="0 0 24 24" width={size} className={className} aria-hidden="true">
    <path
      d="M12 2 l2.9 6.3 6.9 0.7 -5.2 4.7 1.5 6.8 L12 17.3 5.9 20.5 7.4 13.7 2.2 9 9.1 8.3 z"
      fill={color}
      stroke="#e2a12f"
      strokeWidth="0.6"
    />
  </svg>
);

export const Balloon = ({ color = '#ee7a3d', size = 70, className = '' }) => (
  <svg viewBox="0 0 60 100" width={size} className={className} aria-hidden="true">
    <ellipse cx="30" cy="32" rx="22" ry="28" fill={color} />
    <path d="M30 60 l-3 6 l3 6 l3 -6 z" fill={color} />
    <path d="M30 72 Q34 82 28 92 Q32 96 30 100" stroke="#8d5a34" strokeWidth="1.2" fill="none" />
    <ellipse cx="22" cy="22" rx="5" ry="8" fill="rgba(255,255,255,0.55)" />
  </svg>
);

export const HouseLogo = ({ size = 44 }) => (
  <svg viewBox="0 0 60 60" width={size} height={size} aria-hidden="true">
    <path d="M6 30 L30 8 L54 30 L54 52 L6 52 Z" fill="#7bc042" />
    <path d="M6 30 L30 8 L54 30 L48 30 L30 14 L12 30 Z" fill="#5ea333" />
    <rect x="22" y="32" width="16" height="20" fill="#fff7d6" />
    <rect x="22" y="32" width="16" height="20" fill="none" stroke="#5ea333" strokeWidth="1.4" />
    <line x1="30" y1="32" x2="30" y2="52" stroke="#5ea333" strokeWidth="1.2" />
    <line x1="22" y1="42" x2="38" y2="42" stroke="#5ea333" strokeWidth="1.2" />
  </svg>
);

export const Flower = ({ size = 44, color = '#f8d4d0', className = '' }) => (
  <svg viewBox="0 0 60 60" width={size} className={className} aria-hidden="true">
    <g>
      <circle cx="30" cy="14" r="9" fill={color} />
      <circle cx="30" cy="46" r="9" fill={color} />
      <circle cx="14" cy="30" r="9" fill={color} />
      <circle cx="46" cy="30" r="9" fill={color} />
      <circle cx="19" cy="19" r="8" fill={color} />
      <circle cx="41" cy="19" r="8" fill={color} />
      <circle cx="19" cy="41" r="8" fill={color} />
      <circle cx="41" cy="41" r="8" fill={color} />
      <circle cx="30" cy="30" r="9" fill="#ffd868" />
    </g>
  </svg>
);

export const Squirrel = ({ size = 90, className = '', flip = false }) => (
  <svg
    viewBox="0 0 120 100"
    width={size}
    className={className}
    style={{ transform: flip ? 'scaleX(-1)' : 'none' }}
    aria-hidden="true"
  >
    <path d="M78 88 Q118 78 108 40 Q92 30 88 60 Z" fill="#c47443" />
    <ellipse cx="58" cy="70" rx="28" ry="22" fill="#d78754" />
    <circle cx="36" cy="52" r="18" fill="#d78754" />
    <path d="M22 40 L28 30 L34 42 Z" fill="#c47443" />
    <path d="M40 40 L46 30 L48 42 Z" fill="#c47443" />
    <circle cx="30" cy="52" r="2.2" fill="#2a1a10" />
    <path d="M22 58 Q26 62 30 58" stroke="#2a1a10" strokeWidth="1.2" fill="none" />
    <ellipse cx="62" cy="80" rx="14" ry="6" fill="#f4d3b0" />
  </svg>
);

export const House = ({ className = '', size = 620 }) => (
  <svg viewBox="0 0 620 440" width={size} className={className} aria-hidden="true">
    {/* Roof */}
    <defs>
      <linearGradient id="roofGrad" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#e6633d" />
        <stop offset="100%" stopColor="#c74a2a" />
      </linearGradient>
      <linearGradient id="wallGrad" x1="0" x2="0" y1="0" y2="1">
        <stop offset="0%" stopColor="#f6d68a" />
        <stop offset="100%" stopColor="#eab653" />
      </linearGradient>
    </defs>
    <polygon points="70,180 310,50 550,180 550,240 70,240" fill="url(#roofGrad)" />
    {/* Roof tile lines */}
    {Array.from({ length: 8 }).map((_, i) => (
      <line
        key={i}
        x1={90 + i * 55}
        y1={190}
        x2={110 + i * 55}
        y2={230}
        stroke="rgba(0,0,0,0.15)"
        strokeWidth="1.2"
      />
    ))}
    {/* Dormer */}
    <polygon points="260,120 310,80 360,120 360,180 260,180" fill="url(#roofGrad)" />
    <rect x="286" y="140" width="48" height="40" fill="#fff5c7" />
    <path d="M286 140 Q310 120 334 140" fill="#fff5c7" stroke="#8a5a2a" strokeWidth="2" />
    <line x1="310" y1="140" x2="310" y2="180" stroke="#8a5a2a" strokeWidth="1.5" />
    {/* Wall */}
    <rect x="110" y="240" width="400" height="170" fill="url(#wallGrad)" />
    {/* Windows */}
    <rect x="150" y="280" width="90" height="90" fill="#fff5c7" stroke="#8a5a2a" strokeWidth="3" />
    <line x1="195" y1="280" x2="195" y2="370" stroke="#8a5a2a" strokeWidth="2" />
    <line x1="150" y1="325" x2="240" y2="325" stroke="#8a5a2a" strokeWidth="2" />
    <rect x="380" y="280" width="90" height="90" fill="#fff5c7" stroke="#8a5a2a" strokeWidth="3" />
    <line x1="425" y1="280" x2="425" y2="370" stroke="#8a5a2a" strokeWidth="2" />
    <line x1="380" y1="325" x2="470" y2="325" stroke="#8a5a2a" strokeWidth="2" />
    {/* Door */}
    <rect x="280" y="290" width="60" height="120" rx="28" fill="#c14a2a" />
    <circle cx="330" cy="350" r="3" fill="#ffd868" />
    {/* Fence on roof */}
    <rect x="70" y="236" width="480" height="10" fill="#f2c56b" />
    {Array.from({ length: 22 }).map((_, i) => (
      <rect key={i} x={80 + i * 22} y={220} width={6} height={16} fill="#f2c56b" />
    ))}
    {/* Chimney */}
    <rect x="430" y="120" width="32" height="70" fill="#8a3a24" />
    <rect x="424" y="116" width="44" height="10" fill="#5a2418" />
    {/* Flag pole */}
    <line x1="305" y1="50" x2="305" y2="10" stroke="#6b3f22" strokeWidth="3" />
    <path d="M305 12 L338 20 L305 28 Z" fill="#ee7a3d" />
  </svg>
);
